/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Organizer_HintInputs */



/**
* | output |
* | --- |
* | "Show this QR code for players to scan and check in" |
*
* @param {Checkin_Qr_Organizer_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_organizer_hint = /** @type {((inputs?: Checkin_Qr_Organizer_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Organizer_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affichez ce QR code pour que les joueurs pointent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Muestra este código QR para que los jugadores hagan check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mostre este código QR para os jogadores fazerem check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra questo codice QR per permettere ai giocatori di fare il check-in")
	return /** @type {LocalizedString} */ ("Show this QR code for players to scan and check in")
});